import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Heading from "../Heading/Heading";
import Button from "../Button/Button";
import VotingModal from "../VotingModal/VotingModal";
import {voteLimit, voteModalTextPageUID} from "../../config";
import { withPrismic } from "../Prismic/Prismic";

class VotingOpenHeader extends Component {
  state = {
    showVotingModal: false
  };
  openVotingModal = () => {
    this.setState({
      showVotingModal: true
    });
  };
  closeVotingModal = () => {
    this.setState({
      showVotingModal: false
    });
  };

  getText = (uid) => {
    this.props.prismic.getPageData(voteModalTextPageUID).then((content) => {
      this.setState({content: content || ''});
    });
  };

  componentDidMount() {
    if(!this.props.prismic) return null;
    this.getText();
  }

  render() {
    const { content } = this.state

    return (
      <div className="voting-header">
        <div className="copy">
          <Heading>Register to vote!</Heading>
          {this.props.showText
            ? (<p>
              To vote, register first! This will allow you to select your favourites. Once you’re done, click the button at the bottom of the page to submit your votes. You can select up to {voteLimit}{" "} videos.
            </p>)
            : null
          }
        </div>
        <div className="action">
          <Button className="vote-btn" onClick={this.openVotingModal}>Register To Vote</Button>
          {this.props.slug && <Button onClick={this.props.onViewEntries}><i className="icon-down"></i> View all entries</Button>}
        </div>
        {this.state.showVotingModal && (
          <VotingModal
            textBody={content && content.data && content.data.body}
            competitionId={this.props.competitionId}
            handleDismiss={this.closeVotingModal}
          />
        )}
      </div>
    );
  }
}

export default withRouter(withPrismic(VotingOpenHeader));


// WEBPACK FOOTER //
// ./src/components/VotingOpenHeader/VotingOpenHeader.js